@if (currentpage$ | async; as page) {
  @if (page===3) {
    <div class="p-para">
      <div [innerHTML]="(data | async)?.content"></div>
    </div>
  }
}